import { routerRedux } from 'dva/router';
import { doLogout, doLogin } from '../services/user';

export default {
  namespace: 'login',

  state: {
    status: undefined,
    userInfo: {}
  },

  effects: {
    *doLogin({ payload }, { call, put }) {
      const response = yield call(doLogin, payload);
      yield put({
        type: 'saveLogin',
        payload: response,
      });
    },
    *doLogout({ payload }, { call, put }) {
      yield put({
        type: 'saveLogout',
        payload: {
          status: false,
        },
      });
      yield put(routerRedux.push('/user/login'));
    },
  },

  reducers: {
    saveLogin(state, { payload }) {
      console.log('payload: ',payload);
      window.www=345;
      console.log('lgoin: ',window.www);
      return {
        ...state,
        status: payload.status,
        type: payload.type,
      };
    },
    saveLogout(state, { payload }) {
      return {
        ...state,
        submitting: payload,
      };
    },
  },
};
